export default __webpack_public_path__ + "static/part2-sketch-910b738d4a3ffc3903a9941734a684af.jpg";